import { render, staticRenderFns } from "./child-dependencies-warning.vue?vue&type=template&id=b34eda8a&scoped=true"
import script from "./child-dependencies-warning.vue?vue&type=script&lang=js"
export * from "./child-dependencies-warning.vue?vue&type=script&lang=js"
import style0 from "./child-dependencies-warning.vue?vue&type=style&index=0&id=b34eda8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34eda8a",
  null
  
)

export default component.exports